import { useEffect, useCallback } from 'react';
import { getTargetElement } from '../utils/dom';
var defaultEvent = 'click';

var useClickOutside = function useClickOutside(onClickAway, target, eventName) {
  if (eventName === void 0) {
    eventName = defaultEvent;
  }

  var handler = useCallback(function (event) {
    var targets = Array.isArray(target) ? target : [target];
    var targetElements = targets.map(function (targetItem) {
      return getTargetElement(targetItem);
    });

    if (targetElements.some(function (targetElement) {
      return !targetElement || targetElement.contains(event.target);
    })) {
      return;
    }

    onClickAway(event);
  }, [onClickAway, typeof target === 'function' ? undefined : target]);
  useEffect(function () {
    document.addEventListener(eventName, handler);
    return function () {
      document.removeEventListener(eventName, handler);
    };
  }, [eventName, handler]);
};

export default useClickOutside;